/* eslint-disable max-len, no-unneeded-ternary, require-jsdoc, consistent-return */
function init() {
  if (!spaParams) return;
  const {
    pageParams,
    siteParams
  } = spaParams;
  if (!pageParams && !siteParams) return;
  if (pageParams.ddo && pageParams.ddo.page && pageParams.ddo.page.attributes && pageParams.ddo.page.attributes.mbox && !pageParams.ddo.load_adobetarget) {
    window.targetGlobalSettings = {
      bodyHidingEnabled: false
    };
    const notprodUtagSync = 'https://tags.tiqcdn.com/utag/bofa/main/notprod/utag.sync.js';
    const prodUtagSync = 'https://tags.tiqcdn.com/utag/bofa/main/prod/utag.sync.js';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = siteParams.isProd ? prodUtagSync : notprodUtagSync;
    document.body.appendChild(script);
  }
  let externalDDO = false;
  if (!pageParams.ddo && siteParams.ddo) {
    // if only siteDDO (not expected but possible in future), just use values from siteDDO.
    externalDDO = siteParams.ddo;
  } else if (pageParams.ddo && !siteParams.ddo) {
    // if pageDDO and no siteDDO (traditional setup) just use that.
    externalDDO = pageParams.ddo;
  } else if (pageParams.ddo && siteParams && siteParams.ddo) {
    // if pageDDO and siteDDO, pageDDO values overwrite siteDDO values.
    externalDDO = Object.assign(siteParams.ddo, pageParams.ddo);
  }
  const pageInfoTemplate = {
    pageID: null,
    // pageID value (pageID for IBM Pageview tag)
    pageName: null,
    // Not needed.
    standardDART: [],
    // Optional, used with single page applications where the standard DART tags change per pageInfo object. Overwrites the attributes.standardDART value.
    standardDARTes: [],
    // Optional, used with single page applications where the standard DART tags change per pageInfo object. Overwrites the attributes.standardDART value.
    mboxCreateParam: '',
    // Optional, used with single page applications where the mbox ID changes per pageInfo object.
    mboxCreateParam_es: '',
    // Optional, used with single page applications where the mbox ID changes per pageInfo object.
    destinationURL: null,
    // Optional, used if needed to overwrite DOM value
    referringURL: null,
    // Optional, used if needed to overwrite DOM value
    issueDate: null,
    // Date released to prod, provide if CMS/platform offers value.
    language: null,
    // CMS/platform provided, add _ES to pageID if = Spanish
    segmentValue: null,
    // Segmentation values for adlob parameter of Pageview
    appName: null,
    // Name of application for product application forms
    appStepNumber: null,
    // Application step number value
    appStepName: null,
    // Application step name
    attr: '-_--_--_--_--_--_--_--_--_--_--_--_--_--_-'
  };
  const categoryTemplate = {
    primaryCategory: null,
    //  OLB:Content:CustSvc
    addlCategory: null,
    //  Additional categoryID values for use with additional Pageviews in the same DOM instance
    pageType: null //  Future use with target state data collection (content, app, prod, tool, etc)
  };
  const attributesTemplate = {
    searchString: null,
    searchResults: null,
    olbSessionID: null,
    subCampaignCode: null,
    pageIDHistory: [],
    //  Tracks PageID history in case need to reset
    DARTUrl: null,
    //  Deprecated
    stateCookie: false,
    SASIEnabled: false,
    needOLBcookie: false,
    standardDART: [],
    standardDARTes: [],
    clickDART: [],
    clickDARTes: [],
    gaId: [],
    chat: {},
    ddo: true,
    mbox: false,
    sundaysky: {}
  };
  const productTemplate = {
    productInfo: {
      productID: null,
      // eProducts productID (or other enterprise value)
      productName: null,
      // eProducts product name
      qty: null,
      type: null,
      // Optional (feature, add on, eProd item, etc)
      tagIsCalled: false,
      productviewTagFired: false
    },
    category: {
      primaryCategory: null,
      // Product categoryID defined based on business rules.
      addlCategory: null // Additional product category IDs for all products on page.
    },
    attributes: {
      // Extensible attributes for product[n]
    }
  };
  const cartTemplate = {
    cartID: null,
    fulfilmentID: null,
    applicationID: null,
    attributes: {},
    item: [],
    category: {
      primaryCategory: null,
      addlCategory: null
    }
  };
  const cartItemTemplate = {
    productInfo: {
      productID: null,
      // eProducts productID (or other enterprise value)
      productName: null,
      // eProducts product name
      type: null,
      // Optional (feature, add on, eProd item, etc)
      qty: null // Number ordered
    }
  };
  const eventTemplate = {
    // Not needed; conversion event values defined in tag manager
    eventInfo: {
      eventName: null,
      eventAction: null,
      eventPoints: null,
      type: null,
      timeStamp: null,
      effect: null
    },
    category: {
      primaryCategory: null,
      subCategory1: null
    },
    attributes: {
      // Extensible attributes for event[n]
    }
  };
  const userTemplate = {
    segment: null,
    online_id: null,
    name: {
      first: null,
      last: null,
      full: null
    },
    offers: [],
    state: null,
    preferred_rewards_tier: null,
    olb3rdpartyid: null,
    authenticated: false,
    sharedIDs: {}
  };
  if (externalDDO) {
    window.digitalData = {
      pageInstanceID: externalDDO.pageInstanceID !== 'notprod' ? externalDDO.pageInstanceID : 'notprod',
      // prod or notprod -- ability to distinguish environments
      load_adobetarget: externalDDO.load_adobetarget ? true : false,
      // Page level flag to turn on/off Adobe Target. Defaults to false/off.
      load_adobetargetclick: externalDDO.load_adobetargetclick ? true : false,
      // Page level flag to turn on/off Adobe Target click tracking. Defaults to false/off.
      load_audiencemanager: externalDDO.load_audiencemanager === false ? false : true,
      // Page level flag to turn on/off Adobe Audience Manager. Defaults to true/on.
      load_bb: externalDDO.load_bb ? true : false,
      // Page level flag to turn on/off Behavioral Biometrics. Defaults to false/off.
      load_cobrowse: externalDDO.load_cobrowse ? true : false,
      // Page level flag to turn on/off CoBrowse. Defaults to false/off.
      load_convertro: externalDDO.load_convertro === false ? false : true,
      // Page level flag to turn on/off Convertro. Defaults to true/on.
      load_coremetrics: externalDDO.load_coremetrics === false ? false : true,
      // Page level flag to turn on/off Coremetrics. Defaults to true/on.
      load_dart: externalDDO.load_dart ? true : false,
      // Page level flag to turn on/off Google DART. Defaults to false/off.
      load_glance: externalDDO.load_glance ? true : false,
      // Page level flag to turn on/off Glance. Defaults to false/off.
      load_glassbox: externalDDO.load_glassbox ? true : false,
      // Page level flag to turn on/off Glassbox. Defaults to false/off.
      load_millwardbrown: externalDDO.load_millwardbrown ? true : false,
      // Page level flag to turn on/off Millward Brown survays. Defaults to false/off.
      load_onetrust: externalDDO.load_onetrust ? true : false,
      // Page level flag to turn on/off OneTrust. Defaults to false/off.
      load_opinionlabs: externalDDO.load_opinionlabs === false ? false : true,
      // Page level flag to turn on/off Opinion Labs. Defaults to true/on.
      load_phishLabs: externalDDO.load_phishLabs === true ? true : false,
      // Page level flag to turn on/off Phish Labs. Defaults to false/off.
      load_trusteer: externalDDO.load_trusteer ? true : false,
      // Page level flag to turn on/off Trusteer. Defaults to false/off.
      load_touchcommerce: externalDDO.load_touchcommerce === false ? false : true,
      // Page level flag to turn on/off Touch Commerce. Defaults to true/on.
      disable_pageviewonload: externalDDO.disable_pageviewonload ? true : false,
      // stop initial CM page view from firing onload
      page: {
        pageInfo: externalDDO && externalDDO.page && externalDDO.page.pageInfo ? externalDDO.page.pageInfo.map(page => ({
          ...pageInfoTemplate,
          ...page,
          language: document.getElementsByTagName('html')[0].lang.substr(0, 2)
        })) : [pageInfoTemplate],
        category: externalDDO.page && externalDDO.page.category ? {
          primaryCategory: externalDDO.page.category.primaryCategory ? externalDDO.page.category.primaryCategory : null,
          // OLB:Content:CustSvc
          addlCategory: externalDDO.page.category.addlCategory ? externalDDO.page.category.addlCategory : null,
          // Additional categoryID values for use with additional Pageviews in the same DOM instance
          pageType: externalDDO.page.category.pageType ? externalDDO.page.category.pageType : null // Future use with target state data collection (content, app, prod, tool, etc)
        } : categoryTemplate,
        attributes: externalDDO.page && externalDDO.page.attributes ? {
          ah: externalDDO.page.attributes.ah ? externalDDO.page.attributes.ah : null,
          // object used to provide data to Authhub-owned scripts
          searchString: externalDDO.page.attributes.searchString ? externalDDO.page.attributes.searchString : null,
          searchResults: externalDDO.page.attributes.searchResults ? externalDDO.page.attributes.searchResults : null,
          olbSessionID: externalDDO.page.attributes.olbSessionID ? externalDDO.page.attributes.olbSessionID : null,
          subCampaignCode: externalDDO.page.attributes.subCampaignCode ? externalDDO.page.attributes.subCampaignCode : null,
          pageIDHistory: externalDDO.page.attributes.pageIDHistory ? externalDDO.page.attributes.pageIDHistory : [],
          // Tracks PageID history in case need to reset
          DARTUrl: externalDDO.page.attributes.DARTUrl ? externalDDO.page.attributes.DARTUrl : null,
          // Deprecated
          stateCookie: externalDDO.page.attributes.stateCookie ? externalDDO.page.attributes.stateCookie : false,
          SASIEnabled: externalDDO.page.attributes.SASIEnabled ? externalDDO.page.attributes.SASIEnabled : false,
          needOLBcookie: externalDDO.page.attributes.needOLBcookie ? externalDDO.page.attributes.needOLBcookie : false,
          standardDART: externalDDO.page.attributes.standardDART ? externalDDO.page.attributes.standardDART : [],
          standardDARTes: externalDDO.page.attributes.standardDARTes ? externalDDO.page.attributes.standardDARTes : [],
          clickDART: externalDDO.page.attributes.clickDART ? externalDDO.page.attributes.clickDART : [],
          clickDARTes: externalDDO.page.attributes.clickDARTes ? externalDDO.page.attributes.clickDARTes : [],
          gaId: externalDDO.page.attributes.gaId ? externalDDO.page.attributes.gaId : [],
          chat: externalDDO.page.attributes.chat ? externalDDO.page.attributes.chat : {},
          glassbox: externalDDO.page.attributes.glassbox ? externalDDO.page.attributes.glassbox : {},
          ddo: externalDDO.page.attributes.ddo ? externalDDO.page.attributes.ddo : true,
          mbox: externalDDO.page.attributes.mbox ? externalDDO.page.attributes.mbox : false,
          mboxCreateParams: externalDDO.page.attributes.mboxCreateParam ? externalDDO.page.attributes.mboxCreateParam : '',
          mboxCreateParam_es: externalDDO.page.attributes.mboxCreateParam_es ? externalDDO.page.attributes.mboxCreateParam_es : '',
          sundaysky: externalDDO.page.attributes.sundaysky ? externalDDO.page.attributes.sundaysky : {}
        } : attributesTemplate
      },
      product: externalDDO && externalDDO.product ? externalDDO.product.map(product => ({
        ...productTemplate,
        ...product
      })) : [],
      cart: externalDDO && externalDDO.cart ? {
        cartID: externalDDO.cart.cartID ? externalDDO.cart.cartID : null,
        // Before or after submit
        fulfilmentID: externalDDO.cart.fulfilmentID ? externalDDO.cart.fulfilmentID : null,
        applicationID: externalDDO.cart.applicationID ? externalDDO.cart.applicationID : null,
        // Unique ID used to map an application with the backend system(s)
        attributes: externalDDO.cart.attributes ? {
          ...externalDDO.cart.attributes,
          startAppPurchase: externalDDO.cart.attributes && externalDDO.cart.attributes.startAppPurchase ? externalDDO.cart.category.startAppPurchase : false,
          // Used for controlling shop tags in purchasing app, If false, fire Shop 5, if true, fire shop 9
          cartViewTagFired: externalDDO.cart.attributes && externalDDO.cart.attributes.cartViewTagFired ? externalDDO.cart.category.cartViewTagFired : false
        } : {},
        item: externalDDO && externalDDO.cart && externalDDO.cart.item ? externalDDO.cart.item.map(item => ({
          ...cartItemTemplate,
          ...item
        })) : [],
        category: {
          primaryCategory: externalDDO.cart.category && externalDDO.cart.category.primaryCategory ? externalDDO.cart.category.primaryCategory : null,
          // Product categoryID defined based on business rules.
          addlCategory: externalDDO.cart.category && externalDDO.cart.category.addlCategory ? externalDDO.cart.category.Category : null // Additional product category IDs for all products on page.
        }
      } : cartTemplate,
      event: externalDDO && externalDDO.event ? externalDDO.event.map(event => ({
        ...eventTemplate,
        ...event
      })) : [],
      user: externalDDO && externalDDO.user ? {
        //  while W3C specifications user is an array, BAC implamentation is a single object.
        segment: externalDDO.user.segment ? externalDDO.user.segment : null,
        // Customer segmentID values provided at runtime.
        online_id: externalDDO.user.online_id ? externalDDO.user.online_id : null,
        // User's onlineID in OLB.
        name: externalDDO && externalDDO.user && externalDDO.user.name ? {
          first: externalDDO.user.name.first ? externalDDO.user.name.first : null,
          last: externalDDO.user.name.last ? externalDDO.user.name.last : null,
          full: externalDDO.user.name.full ? externalDDO.user.name.full : null
        } : {
          first: null,
          last: null,
          full: null
        },
        offers: externalDDO.user.offers ? externalDDO.user.offers : [],
        state: externalDDO.user.state ? externalDDO.user.state : null,
        preferred_rewards_tier: externalDDO.user.preferred_rewards_tier ? externalDDO.user.preferred_rewards_tier : null,
        // User's PR tier indiciator.
        olb3rdpartyid: externalDDO.user.olb3rdpartyid ? externalDDO.user.olb3rdpartyid : null,
        // OLB 3rd partyID value available in the authenticated space only. It is a base64 encode of the GUID hash made from partyID.
        authenticated: externalDDO.user.authenticated ? externalDDO.user.authenticated : false,
        // This will be false if the user is not authenticated and true if authenticated - used in apps for OLB / NonOLB designation in PageID.
        sharedIDs: externalDDO.user.sharedIDs ? externalDDO.user.sharedIDs : {}
      } : userTemplate,
      version: externalDDO.version ? externalDDO.version : 'BAC_0.25'
    };
  }
  return false;
}

/* eslint-disable camelcase */
init();
window.utag_data = window.utag_data || {};
window.bactm = window.bactm || {
  pageview: function () {},
  addManySegmentValues: function () {},
  addProducts: function () {},
  addProductsToCart: function () {},
  addSegmentValue: function () {},
  cartView: function () {},
  conversion: function () {},
  customError: function () {},
  manualLinkClick: function () {},
  rescanDOM: function () {},
  productsPurchased: function () {},
  productview: function () {},
  revertToPrevPageID: function () {},
  impressions: function () {}
};

/**
 * bactm_getTMEnvBasedOnHostname
 *
 * @param {String} hostname environment hostname
 * @returns {undefined}
 */
function bactm_getTMEnvBasedOnHostname(hostname, profileName) {
  let env = 'prod';
  const envHostname = hostname || window.location.hostname;
  const hostnameParts = envHostname.split('.').reverse();
  const notprodIndicators = profileName === 'ml' ? ['devui', 'dif.hew', 'dif.merrill', 'privatebankdif.', 'wimcc-dif', 'sit1', 'sit2', '.dev', 'dev.', '-dev', 'dev-', 'pt1', 'pt2', 'pl1', 'pl2', 'benefitsse', 'privatebankfssit1', 'privatebankfssit2', 'merrilledgedev', 'merrilledgesit1', 'merrilledgesit2', 'merrillsit1', 'merrillsit2', 'merrilldev'] : ['www-', 'secure-', '-dev', '-stg', 'dev-', '-sit', '-uat', 'review-', 'localhost', 'preview-', '-helix', '.test.paymentsinvoicing', 'testb1.bac', 'benefitsse', 'privatebankfssit1', 'privatebankfssit2', 'devui', 'dif.hew', 'dif.merrill', 'privatebankdif.', 'wimcc-dif', "fssit1", "fssit2"];
  const indicatorsLen = notprodIndicators.length;
  if (hostnameParts.length > 3 && hostnameParts[2] === 'ecnp') env = 'notprod';
  for (let i = 0, partsLen = hostnameParts.length; i < partsLen; i += 1) {
    if (env === 'notprod') break;
    const part = hostnameParts[i];
    for (let j = 0; j < indicatorsLen; j += 1) {
      const indicator = notprodIndicators[j];
      if (part.indexOf(indicator) > -1) {
        env = 'notprod';
        break;
      }
    }
  }
  return env;
}
const merrillSpecificDomains = ['ml.com', 'privatebank', 'merrilledgedev', 'merrilledgesit', 'merrillsit', 'merrilldev'];
let profileName = spaParams?.siteParams?.bactmSiteCollection === 'mlauth' ? 'mlauth' : merrillSpecificDomains.filter(ml => window.location.hostname.includes(ml)).length > 0 ? 'ml' : 'main';
window.bactm_envSelector = bactm_getTMEnvBasedOnHostname(undefined, profileName);
function sanitizeUrl(url) {
  return url.replace(/[^a-z0-9.:/?=&%-]/gi);
}
const sanitizeScript = scriptElement => {
  const checkAttributeNamesValid = attributeNameArray => {
    const validAttributes = ['src', 'type', 'async'];
    return attributeNameArray.sort().toString() === validAttributes.sort().toString();
  };

  // The length of the script tag needs to be less than 120 characters
  if (scriptElement.outerHTML.length < 120) {
    // Check the number of elements (src, type, async)
    if (scriptElement.getAttributeNames().length === 3) {
      // Check for valid attributes
      if (checkAttributeNamesValid(scriptElement.getAttributeNames())) {
        // Check the src for a valid URL 
        let scriptElementSrc = scriptElement.src;
        let testElementRegEx = new RegExp('//tags.tiqcdn.com/utag/bofa/(main|ml|chat|fiserve|mlauth|mcoe|olb)/(prod|notprod|dev\d|sit\d|qa|dev)/utag.js');
        if (testElementRegEx.test(scriptElementSrc)) {
          // Check if async attribute is trued
          if (scriptElement.async === true) {
            // Check if type is 'text/javascript'
            if (scriptElement.type === 'text/javascript') {
              return scriptElement;
            }
          }
        }
      }
    }
  }
};
(function createTealiumTag(a, b, c, d) {
  a = `//tags.tiqcdn.com/utag/bofa/${profileName}/${window.bactm_envSelector}/utag.js`;
  b = document;
  c = 'script';
  d = b.createElement(c);
  d.src = sanitizeUrl(a);
  d.type = `text/java${c}`;
  d.async = true;
  b.body.appendChild(sanitizeScript(d));
})();
